"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Applications API
 * The Tapis Applications API provides for management of Tapis applications including permissions.
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var ApplicationsApi = /** @class */ (function (_super) {
    __extends(ApplicationsApi, _super);
    function ApplicationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Change owner of an application. Applies to all versions.
     * Change application owner
     */
    ApplicationsApi.prototype.changeAppOwnerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.appId === null || requestParameters.appId === undefined) {
                            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling changeAppOwner.');
                        }
                        if (requestParameters.userName === null || requestParameters.userName === undefined) {
                            throw new runtime.RequiredError('userName', 'Required parameter requestParameters.userName was null or undefined when calling changeAppOwner.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps/{appId}/changeOwner/{userName}".replace("{" + "appId" + "}", encodeURIComponent(String(requestParameters.appId))).replace("{" + "userName" + "}", encodeURIComponent(String(requestParameters.userName))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespChangeCountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Change owner of an application. Applies to all versions.
     * Change application owner
     */
    ApplicationsApi.prototype.changeAppOwner = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeAppOwnerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create an application using a request body. App id+version must be unique within tenant and can be composed of alphanumeric characters and the following special characters [-._~]. Id must begin with an alphabetic character and can be no more than 80 characters in length.  Note that certain attributes (such as tenant) are allowed but ignored so that the JSON result returned by a GET may be modified and used when making a POST request to create an application. The attributes that are allowed but ignored are    - tenant   - uuid   - deleted   - created   - updated
     * Create a new version of an application
     */
    ApplicationsApi.prototype.createAppVersionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqPostApp === null || requestParameters.reqPostApp === undefined) {
                            throw new runtime.RequiredError('reqPostApp', 'Required parameter requestParameters.reqPostApp was null or undefined when calling createAppVersion.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ReqPostAppToJSON(requestParameters.reqPostApp),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespResourceUrlFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create an application using a request body. App id+version must be unique within tenant and can be composed of alphanumeric characters and the following special characters [-._~]. Id must begin with an alphabetic character and can be no more than 80 characters in length.  Note that certain attributes (such as tenant) are allowed but ignored so that the JSON result returned by a GET may be modified and used when making a POST request to create an application. The attributes that are allowed but ignored are    - tenant   - uuid   - deleted   - created   - updated
     * Create a new version of an application
     */
    ApplicationsApi.prototype.createAppVersion = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAppVersionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Mark an application as deleted. Application will not appear in queries unless explicitly requested.
     * Mark an application as deleted
     */
    ApplicationsApi.prototype.deleteAppRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.appId === null || requestParameters.appId === undefined) {
                            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling deleteApp.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps/{appId}/delete".replace("{" + "appId" + "}", encodeURIComponent(String(requestParameters.appId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespChangeCountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Mark an application as deleted. Application will not appear in queries unless explicitly requested.
     * Mark an application as deleted
     */
    ApplicationsApi.prototype.deleteApp = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteAppRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Mark an application unavailable for use. Applies to all versions.
     * Mark an application unavailabe for use
     */
    ApplicationsApi.prototype.disableAppRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.appId === null || requestParameters.appId === undefined) {
                            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling disableApp.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps/{appId}/disable".replace("{" + "appId" + "}", encodeURIComponent(String(requestParameters.appId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespChangeCountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Mark an application unavailable for use. Applies to all versions.
     * Mark an application unavailabe for use
     */
    ApplicationsApi.prototype.disableApp = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.disableAppRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Mark an application available for use. Applies to all versions.
     * Mark an application availabe for use
     */
    ApplicationsApi.prototype.enableAppRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.appId === null || requestParameters.appId === undefined) {
                            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling enableApp.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps/{appId}/enable".replace("{" + "appId" + "}", encodeURIComponent(String(requestParameters.appId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespChangeCountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Mark an application available for use. Applies to all versions.
     * Mark an application availabe for use
     */
    ApplicationsApi.prototype.enableApp = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enableAppRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve information for an application given the application Id and version.
     * Retrieve details for specific version of an application
     */
    ApplicationsApi.prototype.getAppRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.appId === null || requestParameters.appId === undefined) {
                            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling getApp.');
                        }
                        if (requestParameters.appVersion === null || requestParameters.appVersion === undefined) {
                            throw new runtime.RequiredError('appVersion', 'Required parameter requestParameters.appVersion was null or undefined when calling getApp.');
                        }
                        queryParameters = {};
                        if (requestParameters.requireExecPerm !== undefined) {
                            queryParameters['requireExecPerm'] = requestParameters.requireExecPerm;
                        }
                        if (requestParameters.select !== undefined) {
                            queryParameters['select'] = requestParameters.select;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps/{appId}/{appVersion}".replace("{" + "appId" + "}", encodeURIComponent(String(requestParameters.appId))).replace("{" + "appVersion" + "}", encodeURIComponent(String(requestParameters.appVersion))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespAppFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve information for an application given the application Id and version.
     * Retrieve details for specific version of an application
     */
    ApplicationsApi.prototype.getApp = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAppRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve latest version of an application.
     * Retrieve latest version of an application
     */
    ApplicationsApi.prototype.getAppLatestVersionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.appId === null || requestParameters.appId === undefined) {
                            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling getAppLatestVersion.');
                        }
                        queryParameters = {};
                        if (requestParameters.requireExecPerm !== undefined) {
                            queryParameters['requireExecPerm'] = requestParameters.requireExecPerm;
                        }
                        if (requestParameters.select !== undefined) {
                            queryParameters['select'] = requestParameters.select;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps/{appId}".replace("{" + "appId" + "}", encodeURIComponent(String(requestParameters.appId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespAppFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve latest version of an application.
     * Retrieve latest version of an application
     */
    ApplicationsApi.prototype.getAppLatestVersion = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAppLatestVersionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve list of applications. Use search and select query parameters to limit results.
     * Retrieve applications
     */
    ApplicationsApi.prototype.getAppsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.search !== undefined) {
                            queryParameters['search'] = requestParameters.search;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['orderBy'] = requestParameters.orderBy;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['skip'] = requestParameters.skip;
                        }
                        if (requestParameters.startAfter !== undefined) {
                            queryParameters['startAfter'] = requestParameters.startAfter;
                        }
                        if (requestParameters.computeTotal !== undefined) {
                            queryParameters['computeTotal'] = requestParameters.computeTotal;
                        }
                        if (requestParameters.select !== undefined) {
                            queryParameters['select'] = requestParameters.select;
                        }
                        if (requestParameters.showDeleted !== undefined) {
                            queryParameters['showDeleted'] = requestParameters.showDeleted;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespAppsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve list of applications. Use search and select query parameters to limit results.
     * Retrieve applications
     */
    ApplicationsApi.prototype.getApps = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAppsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Check if an application is currently enabled, i.e. available for use.
     * Check if application is currently enabled
     */
    ApplicationsApi.prototype.isEnabledRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.appId === null || requestParameters.appId === undefined) {
                            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling isEnabled.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps/{appId}/isEnabled".replace("{" + "appId" + "}", encodeURIComponent(String(requestParameters.appId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespBooleanFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Check if an application is currently enabled, i.e. available for use.
     * Check if application is currently enabled
     */
    ApplicationsApi.prototype.isEnabled = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isEnabledRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update selected attributes of an existing version of an application. Request body may only contain updatable attributes. Application must exist.  Attributes that may not be updated via PATCH are    - id   - owner   - enabled  Note that the attributes owner and enabled may be modified using other endpoints.
     * Update selected attributes of an existing version of an application
     */
    ApplicationsApi.prototype.patchAppRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.appId === null || requestParameters.appId === undefined) {
                            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling patchApp.');
                        }
                        if (requestParameters.appVersion === null || requestParameters.appVersion === undefined) {
                            throw new runtime.RequiredError('appVersion', 'Required parameter requestParameters.appVersion was null or undefined when calling patchApp.');
                        }
                        if (requestParameters.reqPatchApp === null || requestParameters.reqPatchApp === undefined) {
                            throw new runtime.RequiredError('reqPatchApp', 'Required parameter requestParameters.reqPatchApp was null or undefined when calling patchApp.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps/{appId}/{appVersion}".replace("{" + "appId" + "}", encodeURIComponent(String(requestParameters.appId))).replace("{" + "appVersion" + "}", encodeURIComponent(String(requestParameters.appVersion))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ReqPatchAppToJSON(requestParameters.reqPatchApp),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespResourceUrlFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update selected attributes of an existing version of an application. Request body may only contain updatable attributes. Application must exist.  Attributes that may not be updated via PATCH are    - id   - owner   - enabled  Note that the attributes owner and enabled may be modified using other endpoints.
     * Update selected attributes of an existing version of an application
     */
    ApplicationsApi.prototype.patchApp = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchAppRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update all updatable attributes of an application using a request body identical to POST. Application must exist.  Note that certain attributes (such as tenant) are allowed but ignored so that the JSON result returned by a GET may be modified and used when making a PUT request to update.  The attributes that are allowed but ignored for both PUT and POST are    - tenant   - uuid   - deleted   - created   - updated  In addition for a PUT operation the following non-updatable attributes are allowed but ignored    - id   - version   - owner   - enabled  Note that the attributes owner and enabled may be modified using other endpoints.
     * Update all updatable attributes of an application
     */
    ApplicationsApi.prototype.putAppRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.appId === null || requestParameters.appId === undefined) {
                            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling putApp.');
                        }
                        if (requestParameters.appVersion === null || requestParameters.appVersion === undefined) {
                            throw new runtime.RequiredError('appVersion', 'Required parameter requestParameters.appVersion was null or undefined when calling putApp.');
                        }
                        if (requestParameters.reqPutApp === null || requestParameters.reqPutApp === undefined) {
                            throw new runtime.RequiredError('reqPutApp', 'Required parameter requestParameters.reqPutApp was null or undefined when calling putApp.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps/{appId}/{appVersion}".replace("{" + "appId" + "}", encodeURIComponent(String(requestParameters.appId))).replace("{" + "appVersion" + "}", encodeURIComponent(String(requestParameters.appVersion))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ReqPutAppToJSON(requestParameters.reqPutApp),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespResourceUrlFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update all updatable attributes of an application using a request body identical to POST. Application must exist.  Note that certain attributes (such as tenant) are allowed but ignored so that the JSON result returned by a GET may be modified and used when making a PUT request to update.  The attributes that are allowed but ignored for both PUT and POST are    - tenant   - uuid   - deleted   - created   - updated  In addition for a PUT operation the following non-updatable attributes are allowed but ignored    - id   - version   - owner   - enabled  Note that the attributes owner and enabled may be modified using other endpoints.
     * Update all updatable attributes of an application
     */
    ApplicationsApi.prototype.putApp = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.putAppRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve details for applications. Use query parameters to specify search conditions. For example ?owner.eq=jdoe&enabled.eq=false
     * Retrieve list of applications matching search conditions specified as query parameters
     */
    ApplicationsApi.prototype.searchAppsQueryParametersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['orderBy'] = requestParameters.orderBy;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['skip'] = requestParameters.skip;
                        }
                        if (requestParameters.startAfter !== undefined) {
                            queryParameters['startAfter'] = requestParameters.startAfter;
                        }
                        if (requestParameters.computeTotal !== undefined) {
                            queryParameters['computeTotal'] = requestParameters.computeTotal;
                        }
                        if (requestParameters.select !== undefined) {
                            queryParameters['select'] = requestParameters.select;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps/search",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespAppsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve details for applications. Use query parameters to specify search conditions. For example ?owner.eq=jdoe&enabled.eq=false
     * Retrieve list of applications matching search conditions specified as query parameters
     */
    ApplicationsApi.prototype.searchAppsQueryParameters = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchAppsQueryParametersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve details for applications. Use request body to specify SQL-like search conditions.
     * Retrieve applications matching search conditions
     */
    ApplicationsApi.prototype.searchAppsRequestBodyRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqSearchApps === null || requestParameters.reqSearchApps === undefined) {
                            throw new runtime.RequiredError('reqSearchApps', 'Required parameter requestParameters.reqSearchApps was null or undefined when calling searchAppsRequestBody.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['orderBy'] = requestParameters.orderBy;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['skip'] = requestParameters.skip;
                        }
                        if (requestParameters.startAfter !== undefined) {
                            queryParameters['startAfter'] = requestParameters.startAfter;
                        }
                        if (requestParameters.computeTotal !== undefined) {
                            queryParameters['computeTotal'] = requestParameters.computeTotal;
                        }
                        if (requestParameters.select !== undefined) {
                            queryParameters['select'] = requestParameters.select;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps/search",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ReqSearchAppsToJSON(requestParameters.reqSearchApps),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespAppsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve details for applications. Use request body to specify SQL-like search conditions.
     * Retrieve applications matching search conditions
     */
    ApplicationsApi.prototype.searchAppsRequestBody = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchAppsRequestBodyRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Mark an application as not deleted. Application will appear in queries.
     * Mark an application as not deleted
     */
    ApplicationsApi.prototype.undeleteAppRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.appId === null || requestParameters.appId === undefined) {
                            throw new runtime.RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling undeleteApp.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/apps/{appId}/undelete".replace("{" + "appId" + "}", encodeURIComponent(String(requestParameters.appId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespChangeCountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Mark an application as not deleted. Application will appear in queries.
     * Mark an application as not deleted
     */
    ApplicationsApi.prototype.undeleteApp = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.undeleteAppRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ApplicationsApi;
}(runtime.BaseAPI));
exports.ApplicationsApi = ApplicationsApi;
